<div class="console-panel">

  <!-- Console Header -->
  <div class="console-panel__header d-flex align-items-center gap-2 mb-2">
    <span class="console-panel__led console-panel__led--green"></span>
    <span class="console-panel__led console-panel__led--yellow"></span>
    <span class="console-panel__led console-panel__led--red"></span>
    <span class="console-panel__title ms-2">SELECT ACTIVITY</span>
  </div>

  <!-- Console Screen -->
  <div class="console-panel__screen">
    <mat-form-field class="w-100 console-panel__field">
      <mat-select
        #singleSelect
        disableOptionCentering
        [required]="required"
        [formControl]="activityCtrl"
        [placeholder]="placeholder"
      >
        <!-- Search row -->
        <mat-option class="console-panel__search-option">
          <ngx-mat-select-search
            [formControl]="activitiesFilterCtrl"
            [placeholderLabel]="placeholderLabel"
          >
            <mat-icon ngxMatSelectSearchClear *ngIf="!isFinding">close</mat-icon>
            <mat-icon ngxMatSelectSearchClear *ngIf="isFinding">
              <mat-progress-spinner matSuffix mode="indeterminate" diameter="20">
              </mat-progress-spinner>
            </mat-icon>
          </ngx-mat-select-search>
        </mat-option>

        <!-- Activity options -->
        <mat-option
          class="console-panel__option"
          *ngFor="let activity of filteredActivities | async; trackBy: trackItem"
          [value]="activity"
        >
          <div class="d-flex align-items-center gap-2 w-100">
            <span class="console-panel__option-dot"></span>
            <span class="console-panel__option-label">
              {{ 'ADMIN_AGENTS_AUDIT.ACTIVITIES.' + activity | translate }}
            </span>
          </div>
        </mat-option>
      </mat-select>

      <!-- Clear button -->
      <button
        mat-icon-button matSuffix
        *ngIf="activityCtrl.value"
        [attr.aria-label]="'BUTTON.CLEAR' | translate"
        (click)="resetActivity($event)"
        class="console-panel__clear-btn"
      >
        <mat-icon>close</mat-icon>
      </button>

      <mat-hint *ngIf="hint" class="console-panel__hint">{{ hint }}</mat-hint>
      <mat-error *ngIf="errorLabel" class="console-panel__error">{{ errorLabel }}</mat-error>
    </mat-form-field>
  </div>

  <!-- Loading bar -->
  <div class="console-panel__loader-wrap" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate" class="console-panel__loader"></mat-progress-bar>
    <span class="console-panel__loader-label">LOADING…</span>
  </div>

</div>
